import React from "react";

import { Button, Toggle } from "selfly-ui-react";

import "./filter-rule.scss";

import Select from '../../Select/Select';

export function FilterRule(props) {
    function switchNegative() {
        handleChange(props.value, !props.negative);
    }

    function handleChange(newValue, negative = null) {
        if (typeof props.valueSet === "function") {
            if (props.negative !== undefined) {
                props.valueSet({
                    value: newValue,
                    negative: negative !== null ? negative : props.negative,
                });
            } else {
                props.valueSet(newValue);
            }
        } else {
            console.error("An attribute valueSet has to be provided to filter rule");
        }
    }

    const RuleComponent = props.typeComponent !== undefined ? props.typeComponent : FilterTypeDummy;
    return (
        <div className="filter-rule">
            <div className="filter-rule-body">
                <div className="filter-rule-name">
                    <h4>{props.name}</h4>
                </div>
                <div className="filter-rule-reverse">
                    {props.negative !== undefined && (
                        <Button type={props.negative ? "negative" : "positive"} size="md" onClick={switchNegative}>
                            {props.negative ? "IS NOT" : "IS"}
                        </Button>
                    )}
                </div>
                <div className="filter-rule-content">
                    <RuleComponent onChange={handleChange} options={props.options} value={props.value} placeholder={props.placeholder} />
                </div>
            </div>
            {props.help && (
                <div className="filter-rule-help">
                    <p>{props.help}</p>
                </div>
            )}
        </div>
    );
}

export function FilterTypeToggle(props) {
    function click(value) {
        props.onChange(!props.value);
    }

    return (
        <div className="filter-type-toggle">
            <Toggle isActive={props.value} onChange={val => click(val)} />
        </div>
    );
}

export function FilterTypeButtons(props) {
    const { buttons, multiSelect } = props.options;

    function handleClick(btn) {
        if (multiSelect) {
            const newVals = { ...props.value };
            newVals[btn.value] = !props.value[btn.value];
            props.onChange(newVals);
        } else {
            props.onChange(btn.value);
        }
    }

    return (
        <div className="filter-type-buttons">
            {Array.isArray(buttons) &&
                buttons.map(btn => {
                    const selected = multiSelect === true ? props.value[btn.value] === true : props.value === btn.value;
                    return (
                        <Button
                            key={btn.value}
                            value={btn.value}
                            type={selected === true ? "primary" : multiSelect ? "secondary" : "secondary"}
                            onClick={() => handleClick(btn)}
                        >
                            {btn.text}
                        </Button>
                    );
                })}
        </div>
    );
}

export function FilterTypeSelect(props) {

    const { options, openUp, openRight, openLeft, openCenter } = props.options;
    
    function onSelect(value) {
        if(typeof props.onChange === "function") {
            props.onChange(value)
        }
    }

    return <div className="filter-type-select">
        <Select options={options} value={props.value} placeholder={props.placeholder} openUp={openUp} openRight={openRight} openLeft={openLeft} openCenter={openCenter} onChange={onSelect} />
    </div>
}

function FilterTypeDummy(props) {
    return <div className="filter-rule-dummy">Please provide a filter type component as a property...</div>;
}
